export const telephoneMask = (value) => {
    let cleanTelephone = value ? value.replace(/\D/g, "") : ''
    const numberLength = cleanTelephone.length

    if(numberLength > 10) {
        cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7)
    } else if(numberLength > 6 && numberLength < 11) {
        cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6)
    }

    if(numberLength > 2) {
        cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2)
    }

    if(numberLength > 0) {
        cleanTelephone = '(' + cleanTelephone.slice(0)
    }

    return cleanTelephone
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/utils/masks.js